import React from "react";
import RouteSearchPopover from "../../../../../../components/common/RouteSearchPopover";

function renderRouteContent(row) {
    if (!row.flightRouteId) {
        return null;
    }

    const routeName = row.flightRouteFullName || row.flightRouteName || row.flightRouteSummary || `Route #${row.flightRouteId}`;

    return (
        <span title={routeName} style={{ color: "#1890ff", cursor: "pointer", fontSize: 12 }}>
            {routeName}
        </span>
    );
}

const RouteCellRenderer = ({
    row,
    canUpdateFlight,
    isRouteSearchOpen,
    onOpenRouteSearch,
    onCloseRouteSearch,
    onSelectRoute,
}) => {
    const canOpen = Boolean(canUpdateFlight && row?.departureAirport && row?.arrivalAirport);
    const trigger = (
        <span
            className="schedule-draft-rdg-route-cell"
            style={{ display: "inline-flex", alignItems: "center", width: "100%", maxWidth: "100%", height: "100%", cursor: canOpen ? "pointer" : "default" }}
            onMouseDown={(event) => {
                if (canOpen) {
                    event.stopPropagation();
                }
            }}
            onClick={(event) => {
                if (!canOpen) {
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
                onOpenRouteSearch?.(row);
            }}
        >
            {renderRouteContent(row)}
        </span>
    );

    if (!canOpen || !isRouteSearchOpen) {
        return trigger;
    }

    return (
        <RouteSearchPopover
            dep={row.departureAirport}
            arr={row.arrivalAirport}
            aircraftReg={row.aircraftReg}
            open={Boolean(isRouteSearchOpen)}
            onOpenChange={(nextOpen) => {
                if (nextOpen) {
                    onOpenRouteSearch?.(row);
                } else {
                    onCloseRouteSearch?.(row);
                }
            }}
            onClose={() => onCloseRouteSearch?.(row)}
            onSelect={(route) => {
                onSelectRoute?.(row, route);
            }}
        >
            {trigger}
        </RouteSearchPopover>
    );
};

export default RouteCellRenderer;
